// extracted by mini-css-extract-plugin
module.exports = {"container":"TeamInitialAnimation_container__gwgS9","content":"TeamInitialAnimation_content__s_SGv"};